import { render, staticRenderFns } from "./PopupCoordinateEdit.vue?vue&type=template&id=71f0dd1c&scoped=true&"
import script from "./PopupCoordinateEdit.vue?vue&type=script&lang=js&"
export * from "./PopupCoordinateEdit.vue?vue&type=script&lang=js&"
import style0 from "./PopupCoordinateEdit.vue?vue&type=style&index=0&id=71f0dd1c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f0dd1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VSpacer,VTextField})
